import apiRequest from './client';

export const fetchResumeBanqueLottery = ({ bank, tirage, date }) =>
  apiRequest(`/tickets/resume-banque-lottery/?bank=${encodeURIComponent(bank)}&tirage=${encodeURIComponent(tirage)}&date=${encodeURIComponent(date)}`);
